/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import LinkTitle from "src/components/Common/LinkTitle";
import { Headline } from "sunday-component";
import { Container, ListContainer } from "./GuideBook.styled";

export const GuideBook = () => {
  const { t } = useTranslation("affiliate");
  const { locale } = useRouter();

  const guides = [
    {
      displayName: {
        en: "Download product and promotion artworks",
        th: "ดาวน์โหลดภาพผลิตภัณฑ์และโปรโมชันที่น่าสนใจ",
      },
      url: {
        en: "https://drive.google.com/drive/folders/1R04RRVhosUFG2QG6IKoiaiuXp86kYGPc?usp=sharing",
        th: "https://drive.google.com/drive/folders/1R04RRVhosUFG2QG6IKoiaiuXp86kYGPc?usp=sharing",
      },
    },
    {
      displayName: {
        en: "Manual for referring and sharing links",
        th: "วิธีการเขียนข้อความแนะนำและการแชร์ลิงก์",
      },
      url: {
        en: "https://static.easysunday.com/retail/affiliate/pdf/manual_referring_sharing_th_20240820.pdf",
        th: "https://static.easysunday.com/retail/affiliate/pdf/manual_referring_sharing_th_20240820.pdf",
      },
    },
    {
      displayName: {
        en: "Product lists and their unique selling points",
        th: "ผลิตภัณฑ์ประกันภัยที่ร่วมรายการและจุดเด่น",
      },
      url: {
        en: "https://static.easysunday.com/retail/affiliate/pdf/product_list_selling_point_th_20240923.pdf",
        th: "https://static.easysunday.com/retail/affiliate/pdf/product_list_selling_point_th_20240923.pdf",
      },
    },
    {
      displayName: {
        en: "Manual for bank account linking and payout schedule",
        th: "วิธีการผูกบัญชีและระยะเวลาการรับเงิน",
      },
      url: {
        en: "https://static.easysunday.com/retail/affiliate/pdf/manual_bank_payout_th_20240730.pdf",
        th: "https://static.easysunday.com/retail/affiliate/pdf/manual_bank_payout_th_20240730.pdf",
      },
    },
  ];
  return (
    <Container>
      <Headline level={6}>{t("guideBook.title")}</Headline>
      <ListContainer>
        {guides.map((guide) => (
          <li>
            <Link href={guide.url[locale]} passHref>
              <a target="#!">
                <LinkTitle level={7}>{guide.displayName[locale]}</LinkTitle>
              </a>
            </Link>
          </li>
        ))}
      </ListContainer>
    </Container>
  );
};
